export default __webpack_public_path__ + "static/media/icon-table-fuel.b3d3d1ab.svg";